import React, { useEffect, useState } from 'react';
import styles from './index.module.scss';

function HistoryRound(props)
{
    const betWinType_None = 0;
    const betWinType_Slot = 1;
    const betWinType_Cr = 2;
    const betWinType_VideoSlot = 3;
    const blockColors = ['rgba(255, 255, 255)', 'rgba(255, 127, 127)','rgba(127, 127, 255)'];
    const maxBlockCnt = 10;
    const {betWinType, spinCountPerRotate, totalBetDivided, betWin, onFocus} = props;

    //===========================================================================
    const [winType, setWinType] = useState(0);
    const [blocks, setBlocks] = useState([]);
    const [blink, setBlink] = useState(false);
    const [onColor, setOnColor] = useState(false);
    
    useEffect(() => {
        componentDidMount();
        return componentWillUnmount;
    }, []);

    useEffect(() => {
        if (betWin) {
            const {TotalBet, TotalWin, TotalBetInWin, TotalWinInWin, WinA, WinB, WinType} = betWin;
            const dividedBy = totalBetDivided * spinCountPerRotate > 0 ? Math.floor(totalBetDivided * spinCountPerRotate) : 100;
            const iSize = Math.ceil(TotalBet / dividedBy);
            const newBlocks = [];
            for (let i = 0; i < maxBlockCnt; i++) {
                const obj = {
                    index: i,
                    visible: iSize > (maxBlockCnt - 1) - i ? true : false
                }
                newBlocks.push(obj);
            }
            setWinType(WinType);
            setBlocks(newBlocks);
            setBlink(iSize > maxBlockCnt);
        }
    }, [betWin]);

    useEffect(() => {
        if (blink) {
            setTimeout(() => {
                setOnColor(!onColor);
            }, 500);
        }
        else {
            setOnColor(false);
        }
    }, [blink, onColor]);
    //===========================================================================
    
    function componentDidMount()
    {
    }

    function componentDidUpdate()
    {

    }
    
    function componentWillUnmount()
    {
        
    }

    return (
        <div className={styles.round} style={{borderColor:'yellow', borderStyle: 'solid', borderRadius:'2px', borderWidth:`${onFocus ? '1px' : '0'}`}}>
            {
                blocks.map((data, index) => {
                    return (
                        <div key={`roundBlock_${index}`} className={[styles.block, data.visible ? styles.show : styles.hide].join(' ')} style={{backgroundColor:`${index === 0 && onColor ? 'rgb(127, 255, 127)' : 'rgb(255, 255, 255)'}`}}></div>
                    )
                })
            }
            {
                betWinType === betWinType_Slot ? (
                    <div className={[styles.block, winType !== 0 ? styles.show : styles.hide].join(' ')} style={{backgroundColor:`${blockColors[winType]}`}}></div>
                ) : null
            }
            
        </div>
    )
}

export default HistoryRound;